module.exports = __webpack_public_path__ + "img/089-sint-maarten.3951dad6.svg";